module.exports = __webpack_public_path__ + "static/media/evo-firmware-update-hero.5b78a453.png";